// extracted by mini-css-extract-plugin
module.exports = {"cartBar":"AddToCartAnimation_cartBar__Mk5xB","shine":"AddToCartAnimation_shine__J8j6W"};